export default "__VITE_ASSET__CnOIY1s$__"